<template>
<!--  <div style="height:100%;width:100%;position: absolute;">-->
    <vue-draggable-resizable
        ref="draggable"
        :w="width"
        :h="height"
        :x="x"
        :y="y"
        :z="100"
        :min-width="80" :min-height="80"
        :parent="true"
        class="draggable"
        @dragging="handleDragging"
        @dragstop="onDragStop">
      <!-- 这里是你的内容 -->
      <div class="content" @mouseup.prevent="handleClick">
        <img class="img" src="@/assets/imgs/ic-go-to.png">
        <span class="text">去学生端</span>
      </div>
    </vue-draggable-resizable>
<!--    <div v-if="isDragging" class="overlay"></div>-->
<!--  </div>-->
</template>

<script>

export default {
  name: 'Move',
  data () {
    return {
      x: window.innerWidth - 100, // 屏幕宽度减去组件最小宽度
      y: 200,
      maxHeight: window.innerHeight - 200, // 屏幕高度减去组件最小高度
      maxWidth: window.innerWidth - 200, // 屏幕宽度减去组件最小宽度
      width: 80,
      height: 80,
      isDragging: false,
      mouseMoveHandler: null // 用于保存 mousemove 事件的处理程序
    }
  },
  methods: {
    handleDragging (x, y, z) {
      this.isDragging = true
      console.log('Dragging:', x, y, z)
      // 更新位置
      this.x = x
      this.y = y
    },
    onDragStop (event) {
      console.log('onDragstop:', event)
      // 在这里可以处理拖拽停止的逻辑
      setTimeout(() => {
        this.isDragging = false
        console.log('onDragstop', '拖拽结束')
      }, 100)
    },
    handleClick (event) {
      // 点击事件处理函数，跳转到指定网页
      console.log('Clicked!', event)
      console.log('Clicked-isDragging', this.isDragging)
      console.log('Clicked', '点击事件触发')
      if (!this.isDragging) {
        if (this.$loginStudentUrl) {
          window.location.replace(this.$loginStudentUrl)
        }
      } else {
        console.log('Clicked-no', '点击事件被拦截')
      }
    }
  }
}
</script>

<style scoped>

.draggable {
  position: fixed;
  width: 80px;
  height: 80px;
  background-color: #db5647;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000; /* 确保按钮在最顶层 */
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.4);
}

.content {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
}

/* 当鼠标移动到边缘时改变光标，提示可以拖拽 */
.draggable:hover {
  cursor: move; /* Fallback for IE/Edge */
  /* cursor: grab; */
}

/* 当拖拽时改变光标 */
.draggable.dragging {
  cursor: moving; /* Fallback for IE/Edge */
  cursor: grabbing;
}

.img {
  width: 28px;
  height: 28px;
  object-fit: cover;
  user-select: none;
}

.text {
  margin-top: 2px;
  font-size: 12px;
}

/* 遮罩层样式 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.2); /* 透明背景 */
}
</style>
